<template>
  <div class="rt-label-item">
    <el-checkbox-button v-bind="$attrs">
      <slot />
    </el-checkbox-button>
  </div>
</template>

<script>
export default {
  name: 'RtLabelItem'
};
</script>



// WEBPACK FOOTER //
// rtLabelItem.vue?06994431